import ContactSection from './components/contact/ContactSection';
import Hero from './components/contact/Hero';
import Footer from './components/Footer';

const ContactUs = () => {
  return (
    <div>
      <Hero />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default ContactUs;
